import './app/publicPath'

import BKWishlistModule from './app/store/BKWishlistModule'

const Vue = window.Vue

if (!window.ceresStore.hasModule('bkwishlist') && !Vue.prototype.$ceres.isSSR) {
  window.ceresStore.registerModule('bkwishlist', BKWishlistModule)
}

Vue.component('BkWishlist', () => import('./app/components/bkWishlist.vue'))
Vue.component('BkWishlistitem', () => import('./app/components/BkWishlistitem.vue'))
Vue.component('BkCreatewishlist', () => import('./app/components/bkCreatewishlist.vue'))
Vue.component('BkWishlistlist', () => import('./app/components/bkWishlistlist.vue'))
Vue.component('BkAddToWishlist', () => import('./app/components/bkAddToWishlist.vue'))
Vue.component('BkWishlistitemSettings', () => import('./app/components/bkWishlistitemSettings.vue'))
Vue.component('BkLastOpenedWishlists', () => import('./app/components/bkLastOpenedWishlists.vue'))
